var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.449,
    height: 18.322,
    viewBox: "0 0 31.449 18.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.36,30.193H9.4A2.029,2.029,0,0,1,7.38,28.176V22.539a2,2,0,0,1,.585-1.468l5.712-4.978a1.879,1.879,0,0,1,2.489,0l5.55,4.978a2.078,2.078,0,0,1,.66,1.493V28.2a2.029,2.029,0,0,1-2.016,1.991ZM9.869,27.7h9.956V22.726l-4.978-4.343L9.869,22.726Zm10.155-4.841ZM15.37,17.972l-.075.075Z",
    transform: "translate(-7.379 -11.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.079,30.969H19.7a2.315,2.315,0,0,1-2.315-2.315V21.262a2.277,2.277,0,0,1,.672-1.63l7.467-6.484a2.1,2.1,0,0,1,2.725,0l7.38,6.4a2.3,2.3,0,0,1,.747,1.692V28.63a2.315,2.315,0,0,1-2.3,2.34Zm-14.1-2.589H33.8V21.387L26.861,15.4l-6.907,5.986Zm13.913-6.932ZM27.3,15.04h0Z",
    transform: "translate(-4.932 -12.647)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomes);
export default __webpack_public_path__ + "static/media/homes.b5db167566b0adce6148422a1a023458.svg";
export { ForwardRef as ReactComponent };